import styled from "styled-components";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Tag from "../../../../../../../common-deprecated/styles/toyota/Tag";
import { getDirection } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as CashPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { focusStyle } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/toyota/availability-badges/styles/AvailabilityBadgesStyles";

export const CompareWrapper = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    margin-top: auto;
    padding-top: ${theme.space[1]}px;
`;

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 100%;
    padding: ${theme.space[3]}px ${theme.space[3]}px;
    background: ${theme.colors.primaryWhite};
    ${Tag.Eco} {
        display: inline-flex;
        flex-direction: row;
        width: auto;
        height: auto;
        text-align: ${getDirection("left")};
        ${Tag.Motorisation} {
            display: inline-block;
        }
    }
`;

export const Placeholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 150px;
    background-color: ${theme.colors.grey1};
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 126px;
    padding-top: 60%;
    padding-${getDirection("right")}: ${theme.space[4]}px;

    ${ImageFluid},
    ${Placeholder} {
        position: absolute;
        top: 0;
        ${getDirection("left")}: 0;
    }
`;

export const Name = styled.div`
    position: relative;
    margin: 0;
    padding-${getDirection("right")}: 60px;
    text-align: ${getDirection("left")};
    text-transform: none;
    ${Type.SmallText} {
        display: block;
        color: ${theme.colors.grey7};
    }
`;

export const Price = styled.div.attrs(() => ({
    className: "t-base-headline",
}))`
    margin-bottom: ${theme.space[1]}px;
    text-align: ${getDirection("left")};

    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        color: ${theme.colors.primaryBlack};
    }

    + ${AvailabilityBadges} {
        margin-top: ${theme.space[3] / 2}px;
    }
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    margin-top: ${theme.space[3]}px;

    /* Add a focus style to InternalLink */
    a {
        ${focusStyle};
    }
`;

export const GRLogo = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    z-index: 1;
`;
